import {useEffect, useState} from 'react';

const useMountStatus = () => {
    const [unmounted, setUnmounted] = useState(false);

    useEffect(() => {
        setUnmounted(false);
        return () => {
            setUnmounted(true);
        };
    }, [setUnmounted]);

    return unmounted;
};

export default useMountStatus;
